const defaultState = {
  userId: null,
  user_profile: null,


  dataNews: [],
  dataReferensi: [],
  totalPageRegulation: 0,
  dataRegistration: [],
  totalCityRegistration: 0,
  totalProvinceRegistration: 0,
  totalCentralRegistration: 0,
  availableCreateNew: false,
  regisLatest: {},
  dataFKUB: [],
  dataLaporan: [],
  totalPageListFKUB: 0,
  totalReportCity: 0,
  totalReportProvince: 0,
  totalReportCentral: 0,
  dataRumahIbadat: {},
  dataDuplicateCalon: [],
  dataDuplicateMasyarakat: [],
  totalNews: 0,
  dataQuote: [],
  totalQuote: 0,
  dataRegulation: [],
  dataVerificationToken: null,
  errorVerificationToken: null,

  dataArtikel: [],
  dataBeritaPusat: [],
  dataBeritaDaerah: [],
  dataOpini: [],
  totalArtikel: 0,
  totalBeritaPusat: 0,
  totalBeritaDaerah: 0,
  totalOpini: 0,

  dataArtikelPopuler: {},
  dataBeritaPusatPopuler:{},
  dataBeritaDaerahPopuler: {},
  dataOpiniPopuler: {},

  dataArtikelId: {},
  dataBeritaPusatId: {},
  dataBeritaDaerahId: {},
  dataOpiniId: {},

  email: '',
  phone: '',
  province: '',
  region: '',
  role: '', // city, province, central, head of central
  signature: null,
  category_admin: '', // rumah ibadah, ormas, guru
  sub_role: '', // penerimaan, validasi, verifikasi, sinkronisasi, rekomendasi, persetujuan sertifikat (guru => penerimaan, validasi, verifikasi, rekomendasi, persetujuan sertifikat)
  loading: false,
  error: {},
  isLogin: false,
  dataAdmins: [],
  dataRegions: [],
}


function reducer(state = defaultState, action) {
  switch (action.type) {
    case 'SET_USER': {
      return {
        ...state,
        user_profile: action.payload
      }
    }
    case 'USER_LOGOUT': {
      return {
        ...state,
        userId: null,
        name: '',
        loading: false,
        error: {},
        isLogin: false,
        dataReferensi: []
      }
    }
    case 'FETCH_DATA_REFERENSI_SUCCESS': {
      return {
        ...state,
        dataReferensi: action.payload.dataBuku,
        loading: false
      }
    }
    case 'FETCH_DATA_NEWS_SUCCESS': {
      return {
        ...state,
        dataNews: action.payload.dataNews,
        loading: false
      }
    }
    case 'FETCH_DATA_ARTIKEL_SUCCESS': {
      return {
        ...state,
        dataArtikel: action.payload.dataArtikel,
        totalDataArtikel: action.payload.totalDataArtikel,
        loading: false
      }
    }
    case 'FETCH_DATA_BERITA_PUSAT_SUCCESS': {
      return {
        ...state,
        dataBeritaPusat: action.payload.dataBeritaPusat,
        totalDataBeritaPusat: action.payload.totalDataBeritaPusat,
        loading: false
      }
    }
    case 'FETCH_DATA_BERITA_DAERAH_SUCCESS': {
      return {
        ...state,
        dataBeritaDaerah: action.payload.dataBeritaDaerah,
        totalDataBeritaDaerah: action.payload.totalDataBeritaDaerah,
        loading: false
      }
    }
    case 'FETCH_DATA_OPINI_SUCCESS': {
      return {
        ...state,
        dataOpini: action.payload.dataOpini,
        totalOpini: action.payload.totalDataOpini,
        loading: false
      }
    }
    case 'FETCH_DATA_ARTIKEL_ID_SUCCESS': {
      return {
        ...state,
        dataArtikelId: action.payload.dataArtikelId,
        loading: false
      }
    }
    case 'FETCH_DATA_BERITA_PUSAT_ID_SUCCESS': {
      return {
        ...state,
        dataBeritaPusatId: action.payload.dataBeritaPusatId,
        loading: false
      }
    }
    case 'FETCH_DATA_BERITA_DAERAH_ID_SUCCESS': {
      return {
        ...state,
        dataBeritaDaerahId: action.payload.dataBeritaDaerahId,
        loading: false
      }
    }
    case 'FETCH_DATA_OPINI_ID_SUCCESS': {
      return {
        ...state,
        dataOpiniId: action.payload.dataOpiniId,
        loading: false
      }
    }
    case 'FETCH_DATA_ARTIKEL_POPULER_SUCCESS': {
      return {
        ...state,
        dataArtikelPopuler: action.payload.dataArtikelPopuler,
        loading: false
      }
    }
    case 'FETCH_DATA_BERITA_PUSAT_POPULER_SUCCESS': {
      return {
        ...state,
        dataBeritaPusatPopuler: action.payload.dataBeritaPusatPopuler,
        loading: false
      }
    }
    case 'FETCH_DATA_BERITA_DAERAH_POPULER_SUCCESS': {
      return {
        ...state,
        dataBeritaDaerahPopuler: action.payload.dataBeritaDaerahPopuler,
        loading: false
      }
    }
    case 'FETCH_DATA_OPINI_POPULER_SUCCESS': {
      return {
        ...state,
        dataOpiniPopuler: action.payload.dataOpiniPopuler,
        loading: false
      }
    }
    case 'FETCH_DATA_ADMINS_SUCCESS': {
      return {
        ...state,
        dataAdmins: action.payload,
        loading: false
      }
    }
    case 'FETCH_DATA_REGIONS_SUCCESS': {
      return {
        ...state,
        dataRegions: action.payload,
        loading: false
      }
    }
    case 'FETCH_DATA_REGISTRATION_SUCCESS': {
      return {
        ...state,
        dataRegistration: action.payload.dataRegistration,
        totalCityRegistration: action.payload.totalCityRegistration,
        totalProvinceRegistration: action.payload.totalProvinceRegistration,
        totalCentralRegistration: action.payload.totalCentralRegistration,
        availableCreateNew: action.payload.availableCreateNew,
        regisLatest: action.payload.regisLatest,
        loading: false
      }
    }
    case 'FETCH_DATA_REGULATION_SUCCESS': {
      return {
        ...state,
        loading: false,
        dataRegulation: action.payload.dataRegulation,
        totalPageRegulation: action.payload.totalPageRegulation
      }
    }
    case 'FETCH_DATA_LAPORAN_SUCCESS': {
      return {
        ...state,
        dataLaporan: action.payload.dataLaporan,
        totalReportCity: action.payload.totalReportCity,
        totalReportProvince: action.payload.totalReportProvince,
        totalReportCentral: action.payload.totalReportCentral,
        loading: false
      }
    }
    case 'FETCH_DATA_QUOTE_SUCCESS': {
      return {
        ...state,
        ...action.payload,
        loading: false
      }
    }
    case 'FETCH_DATA_REPORT_SUCCESS': {
      return {
        ...state,
        ...action.payload,
        loading: false
      }
    }
    case 'FETCH_DATA_KONSULTASI_SUCCESS': {
      return {
        ...state,
        ...action.payload,
        loading: false
      }
    }
    case 'FETCH_DATA_KONSULTAN_SUCCESS': {
      return {
        ...state,
        ...action.payload,
        loading: false
      }
    }
    case 'FETCH_DATA_RUMAH_IBADAT_SUCCESS': {
      return {
        ...state,
        ...action.payload,
        loading: false
      }
    }
    case 'FETCH_DATA_LIST_FKUB_SUCCESS': {
      return {
        ...state,
        ...action.payload,
        loading: false
      }
    }
    case 'FETCH_DATA_LOADING': {
      return {
        ...state,
        loading: true
      }
    }
    case 'FETCH_DATA_ERROR': {
      return {
        ...state,
        error: action.payload
      }
    }
    case 'VERIFICATION_SUCCESS': {
      return {
        ...state,
        dataVerificationToken: action.payload.dataVerificationToken
      }
    }
    case 'VERIFICATION_ERROR': {
      return {
        ...state,
        errorVerificationToken: action.payload
      }
    }
    default:
      return state
  }
}

export default reducer
